import { configureStore } from "@reduxjs/toolkit"
import { save, load } from "redux-localstorage-simple"
import Rollbar from "rollbar"

import constants from "../Constants"
import { fetchMiddleware } from "./Middleware/apiWrapper"
import reducer from "./Reducers/index"

const rollbar =
  constants.ROLLBAR_KEY &&
  new Rollbar({
    accessToken: constants.ROLLBAR_KEY,
    captureUncaught: false,
    captureUnhandledRejections: false
  })

const preloadedState = load({
  states: ["pyp.navigation", "api.refreshToken", "api.apiToken"]
})

const store = configureStore({
  reducer,
  preloadedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Existing codebase stores some non-serializable data; keep checks off initially
			serializableCheck: false,
			immutableCheck: true
    }).concat(
      fetchMiddleware(rollbar),
      save({ states: ["pyp.navigation"] }),
      save({ states: ["api.refreshToken", "api.apiToken"] })
    ),
  devTools: process.env.NODE_ENV !== "production"
})

export default store
